import * as React from "react";
import "./App.scss";
import privacyPolicy from "../policy/privacy_policy.md?raw";
import termsOfService from "../policy/terms_of_service.md?raw";
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import { connect } from 'react-redux';
// import { Dispatch } from 'redux';
import { MainPrompt } from "./components/prompts";
import { DelayedText } from "./components/DelayedText";

interface AppStates {
  history: React.ReactElement[];
  propmtState: number;
}

const policyPages: Record<string, string> = {
  "/privacy": privacyPolicy,
  "/terms": termsOfService,
};

export class App extends React.Component<{}, AppStates> {
  private _end: HTMLElement | null = null;

  constructor(props: {}) {
    super(props);
    this.state = {
      history: [],
      propmtState: 1,
    };
  }

  public componentDidUpdate() {
    this.scrollToBottom();
  }

  private addHistory(s: React.ReactElement) {
    this.setState({
      history: [...this.state.history, s],
    });
  }

  private pageStateBump() {
    this.setState({
      propmtState: this.state.propmtState + 1,
    });
  }

  public render() {
    const policyText = policyPages[window.location.pathname];
    if (policyText) {
      return this.renderPolicyPage(policyText);
    }

    const asciiArt = [
      `   /\\                         _      _    _        _        `,
      `  /  \\                       | |    | |  | |      (_)       `,
      ` / /\\ \\   ____  ____    ___  | |  _ | |  | |       _  ____  `,
      `| |__| | / ___)|  _ \\  / _ \\ | | / || |  | |      | ||  _ \\ `,
      `|  __  || |    | | | || |_| || |( (_| |  | |_____ | || | | |`,
      `|_|  |_||_|    |_| |_| \\___/ |_| \\____|  |_______)|_||_| |_|`,
    ].join("\n");

    const introduction = [
      "Hello. Welcome to my personal site - a site containing most of what you expect; " +
        "a place embedding some suprises; a playground filled with my imagination.",
      "If you are also a geek, feel free to tweak around - but be aware what you type...",
      "Else, a more human (non-geek) friendly version is coming up...",
    ].join("\n");

    const regions = [
      <p className="ascii-art">
        <DelayedText
          text={asciiArt}
          delay={2}
          callback={this.pageStateBump.bind(this)}
        />
      </p>,
      <p className="introduction-header">
        <DelayedText
          text={introduction}
          delay={15}
          callback={this.pageStateBump.bind(this)}
        />
      </p>,
      this.renderPromptRegion(),
    ];
    return (
      <>
        <div className="main">
          {regions.slice(0, this.state.propmtState)}
          <div
            ref={(e) => {
              this._end = e;
            }}
          />
        </div>
        <footer className="site-footer" aria-label="Legal links">
          <a href="/privacy">privacy</a>
          <span>|</span>
          <a href="/terms">terms</a>
        </footer>
      </>
    );
  }

  private renderPolicyPage(markdown: string) {
    return (
      <main className="policy-page">
        <div className="policy-document">{this.renderMarkdown(markdown)}</div>
      </main>
    );
  }

  private renderMarkdown(markdown: string) {
    const lines = markdown.split("\n");
    const elements: React.ReactElement[] = [];
    let listItems: string[] = [];

    const flushList = () => {
      if (!listItems.length) {
        return;
      }

      elements.push(
        <ul key={`list-${elements.length}`}>
          {listItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      );
      listItems = [];
    };

    lines.forEach((line, index) => {
      const trimmed = line.trim();
      if (!trimmed) {
        flushList();
        return;
      }

      if (trimmed.startsWith("* ")) {
        listItems.push(trimmed.slice(2));
        return;
      }

      flushList();
      if (trimmed.startsWith("### ")) {
        elements.push(<h3 key={index}>{trimmed.slice(4)}</h3>);
      } else if (trimmed.startsWith("# ")) {
        elements.push(<h1 key={index}>{trimmed.slice(2)}</h1>);
      } else {
        elements.push(<p key={index}>{trimmed}</p>);
      }
    });

    flushList();
    return elements;
  }

  private renderPromptRegion() {
    return (
      <div>
        {this.state.history}
        <MainPrompt
          promptText={`geek_visitor@${window.location.hostname}:~$ `}
          submitHistory={this.addHistory.bind(this)}
        />
      </div>
    );
  }

  private scrollToBottom() {
    if (this._end) {
      this._end.scrollIntoView({ behavior: "smooth" });
    }
  }
}
